<p>manage-account works!</p>
